import axios from 'axios';
const base = 'task';

function getOTServicio(query = null) {
  return Promise.resolve({ ots: [] });
  {/* ZTASK-PRODUCCION */}
  /* return axios.get(`${base}/ot/servicio`, { params: query }); */
}

const ZTaskService = {
  getOTServicio
};
export default ZTaskService;
